export const serviceData = [
                {
                    id: 'consulting',
                    title: "Consulting Services for Entrepreneurs",
                    icon: <i class="fi fi-sr-messages custom-brown"></i>,
                    price: "$150",
                    period: "per 60-minute session",
                    bgColor: "bg-custom-olive",
                    features: [
                        "One-on-one guidance",
                        "Customized action plans",
                        "Follow-up resources"
                    ],
                    fullDescription: "One-on-one personalized guidance sessions designed to address your unique challenges and goals. Each session is tailored to your specific situation, providing you with practical strategies and tools you can implement immediately.",
                    whatToExpect: [
                        "Business Strategy & Planning - Tailored business plans, market analysis, and growth strategies for startups and small businesses.",
                        "Time Management & Productivity Coaching - Techniques to optimize daily workflow and increase efficiency.",
                        "Brand Development & Marketing Guidance - Support in creating a strong brand identity and effective marketing strategies.",
                        "Financial Planning & Budgeting - Help with cash flow management, budgeting, and financial forecasting.",
                        "Work-Life Integration - Coaching to balance entrepreneurial drive with personal life, including family priorities"
                    ],
                    idealFor: [
                        "Entrepreneurs and small business owners looking to refine their strategy, scale their operations, or strengthen their brand presence",
                        "Nonprofit leaders and community organizers seeking guidance on program development, fundraising, and sustainable growth",
                        "Individuals facing specific challenges such as team dynamics, financial planning, or mission alignment who need tailored, actionable supportParents wanting to improve communication with their children",
                    ],
                    sessionStructure: "Each 60-minute session includes assessment, strategy development, skill practice, and action planning. Sessions can be conducted virtually or in-person based on your preference.",
                    buttonColor: "custom-red",
                    learnMoreColor: "text-custom-red"
                },
                {
                    id: 'consultingP',
                    title: "Consulting Services for Parents",
                    icon: <i class="fi fi-sr-messages custom-brown"></i>,
                    price: "$150",
                    period: "per 60-minute session",
                    bgColor: "bg-custom-olive",
                    features: [
                        "One-on-one guidance",
                        "Customized action plans",
                        "Follow-up resources"
                    ],
                    fullDescription: "One-on-one personalized guidance sessions designed to address your unique challenges and goals. Each session is tailored to your specific situation, providing you with practical strategies and tools you can implement immediately.",
                    whatToExpect: [
                        "Parenting Strategy Development - Personalized guidance to build effective parenting techniques that promote healthy child development and family harmony.",
                        "Work-Life Balance Coaching - Helping parents create sustainable routines that balance career demands and family time.",
                        "Behavioral Support & Conflict Resolution - Strategies to manage challenging child behaviors and improve family communication.",
                        "Education & Learning Support - Advice on fostering a positive learning environment and choosing appropriate educational resources.",
                        "Parental Wellness & Self-Care - Encouraging parents to prioritize their mental and physical health for overall family wellbeing."
                    ],
                    idealFor: [
                        "Parents seeking practical strategies to improve communication and strengthen relationships with their children",
                        "Parents facing behavioral challenges with their children and needing effective conflict resolution techniques",
                        "Parents prioritizing their own wellness and self-care while managing family responsibilities"
                    ],
                    sessionStructure: "Each 60-minute session includes assessment, strategy development, skill practice, and action planning. Sessions can be conducted virtually or in-person based on your preference.",
                    buttonColor: "custom-red",
                    learnMoreColor: "text-custom-red"
                },
                {
                    id: 'mentorship',
                    title: "PWP Commnuity Mentorship",
                    icon: <i class="fi fi-sr-users custom-brown"></i>,
                    price: "$49",
                    period: "per month",
                    bgColor: "bg-custom-olive",
                    // badge: "Most Popular",
                    borderColor: "border-2 border-custom-gold",
                    features: [
                        "All workshops included",
                        "Support group access",
                        "Resource library",
                        "Monthly group calls"
                    ],
                    fullDescription: "Connect with experienced mentors who understand your journey and are committed to helping you reach your full potential. Our mentorship program pairs you with guides who offer wisdom, accountability, and encouragement as you navigate personal, professional, or educational growth.",
                    whatToExpect: [
                        "One-on-one mentorship matching based on your goals and needs",
                        "Regular check-ins and guidance sessions with your mentor",
                        "Access to mentorship workshops and skill-building events",
                        "Community networking opportunities with other mentees and mentors",
                        "Resource sharing and personalized development plans"
                    ],
                    idealFor: [
                        "Young professionals seeking career guidance and leadership development",
                        "Students navigating academic decisions and future planning",
                        "Individuals pursuing entrepreneurship or creative ventures",
                        "Anyone looking for accountability, wisdom, and connection during times of transition"
                    ],
                    programBenefits: "Mentees gain clarity, confidence, and community support while building meaningful relationships that often last a lifetime.",
                    buttonColor: "custom-gold",
                    learnMoreColor: "text-custom-gold"
                },
                {
                    id: 'advocacy',
                    title: "Commuity Advocate Services",
                    icon: <i class="fi fi-ss-leader-speech custom-brown"></i>,
                    price: "$200",
                    period: "per case/month",
                    bgColor: "bg-custom-olive",
                    features: [
                        "School system advocacy",
                        "Legal support coordination",
                        "Resource navigation",
                        "Crisis intervention"
                    ],
                    fullDescription: "Navigate complex systems and advocate for your family's needs with professional support. Our advocacy services help you communicate effectively with schools, community leaders, and other institutions to ensure your family receives appropriate support and services.",
                    whatToExpect: [
                        "School system advocacy including IEP and 504 plan support",
                        "Financial literacy and money management education",
                        "Legal system support and resource coordination",
                        "Crisis intervention and emergency family support",
                        "Cultural enrichment activities and community outreach"
                    ],
                    idealFor: [
                        "Parents who value both practical life skills and cultural enrichment for their children",
                        "Parents looking for support that includes educational, social, and financial empowerment",
                        "Families dealing with school disciplinary issues or academic concerns",
                        "Those needing support accessing community resources and services"
                    ],
                    advocateApproach: "Our advocates work alongside you, not for you, empowering you with knowledge and skills while providing professional support during challenging situations.",
                    buttonColor: "custom-olive",
                    learnMoreColor: "text-custom-olive"
                }
            ];